import React from "react"

const LinkToSalesforce = (props) => {
  const obj = props.obj;
  if (obj.Id===undefined) {
    return <></>
  }
  return (
    <a
      href={`https://schoeffel.my.salesforce.com/${obj.Id}`}
      rel="noopener noreferrer"
      target="_blank"
      className="salesforce-padding"
      title="Ansicht in Salesforce"
    >
      <img
        src="https://assets-crm.schoeffel.de/public/images/assets/salesforce.png"
        width="16px"
        height="16px"
        alt="Salesforce"
      />
    </a>
  );
}

export default LinkToSalesforce;
